import { useParams } from 'react-router-dom'
import Map from 'containers/Maps/Map'
import { useState } from 'react'
import Filters from './Filters'
import List from './List'

import './style.scss'
import 'containers/Maps/style.scss'

const map = <Map isDesktop />
const Search = () => {
  const [isWideMap, setWideMap] = useState(false)
  const { placeId } = useParams<{ placeId?: string }>()

  const isList = !placeId

  return (
    <div className={`search ${isList ? '--list' : ''}`}>
      <Filters />
      <div className={`search__content ${isWideMap && isList ? '--wide' : !isList ? "--place" : ""}`}>
        <List />
        <div className="search__right">
          <div className="map__wrap maps">
            {map}
          </div>
          {isList && <button
            className="btn"
            onClick={() => {
              setWideMap(!isWideMap)
            }}>
            <i className={`icon icon--arrow-left-hide ${isWideMap ? '--rotate' : ''}`}></i>
          </button>}
        </div>
      </div>
    </div >
  )
}

export default Search